export default __webpack_public_path__ + "static/media/tampering_img_1.36146b64.png";